export enum ConfigLevelType {
  AGENCY = <any>'AGENCY',
  BRAND = <any>'BRAND',
  CHAIN = <any>'CHAIN',
  PROPERTY = <any>'PROPERTY',
  SYSTEM = <any>'SYSTEM',
  UNKNOWN = <any>'UNKNOWN'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/config-level-type.ts